(function( $, doc ) {
    "use strict";

    (function(){

        $( function() {

            // WIZARD menu
            $(".wpmudev-tabs-page").tabs();

            // SIDEBAR menu
            $(".wpmudev-sort-fields").tabs();
            
        } );

    }());

}( jQuery, document ));